import { render, staticRenderFns } from "./production-edit.vue?vue&type=template&id=04505c08&scoped=true&"
import script from "./production-edit.vue?vue&type=script&lang=js&"
export * from "./production-edit.vue?vue&type=script&lang=js&"
import style0 from "./production-edit.vue?vue&type=style&index=0&id=04505c08&prod&lang=scss&"
import style1 from "./production-edit.vue?vue&type=style&index=1&id=04505c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04505c08",
  null
  
)

export default component.exports